module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightCond.541eea8.woff";